/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect, Children } from 'react';
import classNames from 'classnames';
import { ArrowLeft, ChevronRight } from 'react-feather';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { IconButton } from '..';

export const Crumb = ({
  href,
  onClick,
  newTab = false,
  underline = false,
  isActive,
  children,
}) => {
  const TextComponent = () => (
    <Text
      variant={isActive ? TEXT_VARIANTS.BODY_BOLD : TEXT_VARIANTS.BODY}
      className="to-e ws-nw ov-h ui-Breadcrumbs-path"
    >
      {children}
    </Text>
  );
  if (onClick) {
    return (
      <button
        className="u-resetBtn"
        type="button"
        onKeyDown={e => {
          e.preventDefault();
          if (e.key === 'Enter') {
            onClick();
          }
        }}
        onClick={onClick}
        aria-current={isActive ? 'page' : undefined}
      >
        <TextComponent />
      </button>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={classNames({ 'h-td-n': !underline })}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noreferrer' : undefined}
        aria-current={isActive ? 'page' : undefined}
      >
        <TextComponent />
      </a>
    );
  }

  return (
    <div className="d-f fd-r ai-c">
      <ChevronRight size={20} className="mr-4 minw-25 ui-Breadcrumbs-icon" />
      <TextComponent />
    </div>
  );
};

const Breadcrumbs = ({
  parentTitle,
  parentUrl = '/',
  children = null,
  hideNav = false,
  className,
}) => {
  useEffect(() => {
    if (hideNav) {
      pubsub.publish('hideNav', true);
    }

    return () => {
      if (hideNav) {
        pubsub.publish('hideNav', false);
      }
    };
  }, [hideNav]);
  const validLinks = Children.toArray(children).filter(child => child !== null);

  return (
    <nav
      aria-label="Breadcrumb"
      className={classNames('d-f fd-r ai-c ws-nw ov-h', className)}
    >
      <IconButton
        outlined
        disableHover
        className="mr-8"
        aria-label={t('common.back')}
        isLinked
        url={parentUrl}
      >
        <ArrowLeft className="ui-Breadcrumbs-icon" />
      </IconButton>

      {/*
       * eslint-disable-next-line jsx-a11y/no-redundant-roles
       * https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility_concerns
       */}
      <ol role="list" className="d-f fd-r ai-c ws-nw ov-h mb-0 ls-n">
        {parentTitle && (
          <li>
            <a href={parentUrl} className="h-td-n">
              <Text className="mr-4" variant={TEXT_VARIANTS.BODY}>
                {parentTitle}
              </Text>
            </a>
          </li>
        )}
        {validLinks.map((link, i) => {
          return (
            <li
              key={link.props.children}
              className={classNames('mr-4 ui-Breadcrumbs-wrap', {
                'ml-8': i === 0 && !parentTitle,
              })}
            >
              {(i === 0 && !parentTitle) ||
              validLinks?.length - 1 === i ? null : (
                <ChevronRight
                  size={20}
                  className="mr-4 minw-25 ui-Breadcrumbs-icon"
                />
              )}
              {React.cloneElement(link, {
                ...link.props,
                isActive: validLinks?.length - 1 === i,
              })}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
